'use strict';

angular.module('schoolbushubApp')
    .controller('SchoolCodeController', function (SchoolCode, $stateParams, $state) {
        SchoolCode.set($stateParams.schoolCode);
        $state.transitionTo('register');
    });
